import { render } from "./MenuHorizontal.vue?vue&type=template&id=367bcc48&scoped=true&ts=true"
import script from "./MenuHorizontal.vue?vue&type=script&lang=ts"
export * from "./MenuHorizontal.vue?vue&type=script&lang=ts"

import "./MenuHorizontal.vue?vue&type=style&index=0&id=367bcc48&scoped=true&lang=css"

import exportComponent from "C:\\Users\\leonardo.wolber\\Documents\\GitHub\\LimaTec\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-367bcc48"]])

export default __exports__